import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["gauge", "gaugeDescription", "activityList"]
  static values = {
    data: Object,
    options: Object,
    label: String
  }

  connect() {
    this.initializeGaugeChart()
  }

  handleFilterChange(event) {
    const form = event.target.closest('form')
    if (form) {
      form.submit()
    }
  }

  initializeGaugeChart() {
    if (this.hasGaugeTarget) {
      this.chart = new Chart(this.gaugeTarget, {
        type: 'gauge',
        data: this.dataValue,
        options: this.optionsValue
      })
    }
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }
}
